export default __webpack_public_path__ + "static/media/arrow_blue_down_pop.1057a1ed.svg";